// src/components/DashboardLayout.js
import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../services/api";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../Layout/Sidebar";
import Topbar from "../Layout/Topbar";
import { ToastContainer, toast } from "react-toastify";
import { useToast } from "../../contexts/ToastContext";
import { apiRequest } from "../../services/api";
import Loader from "../Common/Loader";
import { Breadcrumb } from "react-bootstrap";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { encryptData } from "../Common/encryptionUtils";
import Shimmer from "../Common/Shimmer";
import "./Users.css";
import { AccessLog } from "../../Utils/AccessLog";
import TextField from "@mui/material/TextField";
import CryptoJS from "crypto-js";
import VerifyUserPasscode from "./VerifyUserPasscode";
import InStatusImage from "../../assets/OnlineLoading_withBg.gif";

const Users = () => {
  const secretKey = "BusinessTimeWebKiosk";
  const location = useLocation();
  const { verified } = location.state || {};

  console.log("verified--->", verified);

  const [premiseData, setPremiseData] = useState(null);

  useEffect(() => {
    AccessLog("Users");
    const stored = localStorage.getItem("verificationToken");
    console.log("stored--->", stored);
    if (stored) {
      const bytes = CryptoJS.AES.decrypt(stored, secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      console.log("decrypted--->", decrypted);
      if (decrypted !== "verified:true") {
        navigate("/premises");
      }
    } else {
      navigate("/premises");
    }
  }, []);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const pageLoading = (data) => {
    setLoading(data);
  };

  const [popupOpen, setPopupOpen] = useState(false);
  const [userData, setUserData] = useState([]);

  const authToken = localStorage.getItem("authToken");

  const Title = "Users";

  const { toastMessage, clearToast } = useToast();
  const [userList, setUserList] = useState([]);
  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );
  const [searchTerm, setSearchTerm] = useState(""); // New state for search term

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value); // Update the search term as user types
  };

  const filteredUser = userList.filter((user) => {
    const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
    return fullName.includes(searchTerm.toLowerCase());
  });

  useEffect(() => {
    if (toastMessage) {
      toast.success(toastMessage);
      clearToast(); // Clear the toast message after displaying it
    }
  }, [toastMessage, clearToast]);

  const selectedTopBarPremises = JSON.parse(
    localStorage.getItem("selectedTopBarPremises")
  );

  const fetchAlluser = async (premise_id) => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const userResponse = await apiRequest(
        `api/user/getstaffdetailsbypremise?type=${encryptData(
          "console"
        )}&premise_id=${encryptData(premise_id?.toString())}`,
        "GET",
        null,
        headers
      );

      if (
        userResponse?.data?.status_code === 200 &&
        userResponse?.data?.data?.staffdetails
      ) {
        const user_details = userResponse.data?.data?.staffdetails;
        console.log("UserDetails-->", user_details);
        const sortedUsers = user_details?.sort((a, b) =>
          a.first_name.localeCompare(b.first_name)
        );
        setUserList(sortedUsers);
        localStorage.setItem("UserList", JSON.stringify(user_details));
        localStorage.removeItem("stepUserOneData");
        localStorage.removeItem("stepUserTwoData");
        localStorage.removeItem("stepExistUserOneData");
        localStorage.removeItem("stepExistUserTwoData");
        setTimeout(() => {
          pageLoading(false);
        }, 100);
      } else {
        setTimeout(() => {
          pageLoading(false);
        }, 100);
        console.error(
          "Error: Invalid status code",
          userResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  useEffect(() => {
    pageLoading(true);
    fetchAlluser(selectedTopBarPremises?.value);

    // Set interval to call every 1 minute (60000 ms)
    const interval = setInterval(() => {
      pageLoading(true);
      fetchAlluser(selectedTopBarPremises?.value);
    }, 30000);

    // Cleanup interval when component unmounts
    return () => clearInterval(interval);
  }, [selectedTopBarPremises?.value]);

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handleUserClick = (userData) => {
    console.log("userDetails--->", userData);
    setUserData(userData);
    setSearchTerm("");
    if (premiseData[0]?.kiosk_passcode_enabled == "true") {
      setPopupOpen(true);
    } else {
      const encrypted = CryptoJS.AES.encrypt(
        "verifiedPasscode:true",
        secretKey
      ).toString();
      localStorage.setItem("verificationPasscodeToken", encrypted);
      navigate("/users/chechkInOut", {
        state: { user_id: userData?.user_id, premiseData }, // replace with your dynamic ID
      });
    }
  };

  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
      pageLoading(true);
      fetchAlluser(selected.value);
      setSelectedPremise(selected);
    } else {
      setUserList([]); // Clear the user list if no premise is selected
    }
  };

  const fetchPremiseDetails = async (premiseData) => {
    const authToken = localStorage.getItem("authToken");
    const headers = {
      Authorization: `Bearer ${authToken}`,
    };
    const response = await apiRequest(
      `web_api/admin/getPremiseDetailsById?premise_id=${premiseData?.premise_id}`,
      "GET",
      null,
      headers
    );
    if (response?.data?.status_code == 200) {
      setPremiseData(response.data?.data);
    } else {
      setPremiseData(null);
    }
  };

  useEffect(() => {
    fetchPremiseDetails(selectedPremise);
  }, []);

  console.log("premiseData--->", premiseData);

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        <div className="content">
          <div className="contentHeader d-flex align-items-center justify-content-end pb-3">
            <div className="search-bar">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearchChange} // Handle input change
                autoComplete="off"
                name="search_query_user"
              />
            </div>
          </div>
          <div className="premiseDetails">
            <div className="row premisesListDiv">
              <div className="row mt-0 mb-0 g-4">
                {loading ? (
                  Array(18)
                    .fill(0)
                    .map((_, index) => (
                      <div
                        className="col-6 col-md-4 col-lg-3 col-xxl-3"
                        key={index}
                        style={{
                          padding: "10px", // Optional: add some padding to match layout
                        }}
                      >
                        <div
                          className="card setting-card position-relative"
                          style={{
                            borderRadius: "10px",
                            padding: "0px 0px",
                            backgroundColor: "#ffffff",
                            fontFamily: "'Poppins', sans-serif",
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                            border: "none",
                            height: "200px",
                          }}
                        >
                          {/* Shimmer effect in the card */}
                          <Shimmer width="100%" height={226} />
                          {/* Additional shimmer effects for other parts */}
                        </div>
                      </div>
                    ))
                ) : filteredUser.length > 0 ? (
                  filteredUser
                    .filter(
                      (userData) =>
                        userData?.user_active_status === "true" &&
                        userData?.user_account_status === "true"
                    )
                    .map((userData, index) => (
                      <div
                        className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center"
                        key={index}
                      >
                        <div className="card setting-card position-relative">
                          <div className="user-status-indicator position-absolute top-0 start-0 m-2">
                            {userData?.user_status === "in" && (
                              <img
                                src={InStatusImage} // Replace with actual green gif path
                                alt="In"
                                className="status-icon"
                              />
                            )}
                            {userData?.user_status === "out" && (
                              <div className="status-out" title="Out"></div>
                            )}
                            {userData?.user_status === "inout" && (
                              <div className="status-inout" title="Break"></div>
                            )}
                            {userData?.user_status === "paid_break" && (
                              <div
                                className="status-paid_break"
                                title="Break"
                              ></div>
                            )}
                            {userData?.user_status === "unpaid_break" && (
                              <div
                                className="status-unpaid_break"
                                title="Break"
                              ></div>
                            )}
                            {userData?.user_status === "offline" && (
                              <div
                                className="status-offline"
                                title="Break"
                              ></div>
                            )}
                          </div>

                          <div
                            className={`card-image-div card-mainDiv ${
                              userData?.user_active_status !== "true"
                                ? "inActiveUser"
                                : ""
                            } 
                          ${
                            userData?.user_account_status !== "true"
                              ? "deactivateUser"
                              : ""
                          }`}
                          >
                            <div className="card-image-round-div">
                              <img
                                src={
                                  userData?.photo
                                    ? userData?.photo
                                    : "https://businesstime.app/business-i_backend_uat/public/uploads/dummyuser.png"
                                }
                                className="cardImageTop rounded-circle mx-auto img-fluid"
                                alt="userImage"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleUserClick(userData);
                                }}
                              />
                            </div>
                          </div>

                          <div
                            className={`card-body ${
                              userData?.user_active_status !== "true"
                                ? "inActiveUser"
                                : ""
                            } 
                          ${
                            userData?.user_account_status !== "true"
                              ? "deactivateUser"
                              : ""
                          }`}
                          >
                            <h5
                              className="card-title"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleUserClick(userData);
                              }}
                            >
                              {userData?.first_name && userData?.last_name
                                ? `${userData?.first_name} ${userData?.last_name}`
                                    .length > 16
                                  ? `${userData?.first_name.slice(
                                      0,
                                      10
                                    )} ${userData?.last_name.slice(0, 0)}...`
                                  : `${userData?.first_name} ${userData?.last_name}`
                                : ""}
                            </h5>
                            <p
                              className="card-text"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleUserClick(userData);
                              }}
                            >
                              {userData?.customer_account_users_id
                                ? "Super User"
                                : capitalizeFirstLetter(userData?.access_level)}
                            </p>
                          </div>
                          {/* Three-dot menu */}
                        </div>
                      </div>
                    ))
                ) : (
                  <div
                    className="noPolicyDiv d-flex flex-column align-items-center justify-content-start vh-100 bg-custom"
                    style={{
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      color: "#fff",
                      textAlign: "center",
                    }}
                  >
                    <h1
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        color: "#2d64bc",
                      }}
                    >
                      No User Found
                    </h1>
                    {/* <p
                      style={{
                        fontSize: "0.9rem",
                        marginTop: "10px",
                        maxWidth: "600px",
                        color: "#6c6c6c",
                      }}
                    >
                      Currently, there are no users available. Create a new user
                      to get started.
                    </p> */}
                    {/* <button
                      className="btn policyAddBtn"
                      style={{ padding: "4px 10px", fontSize: "0.8rem" }}
                      onClick={handleAddPremise}
                    >
                      <i className="fa fa-plus p-1" aria-hidden="true"></i>
                      Create Premises
                    </button> */}
                  </div>
                )}
              </div>
            </div>
          </div>

          {popupOpen && (
            <VerifyUserPasscode
              open={popupOpen}
              handlePopUpClose={() => setPopupOpen(false)}
              navigate={navigate}
              userData={userData}
              setLoading={setLoading}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Users;
